import {
  getCategoryList,
  getCategoryDetail,
  getVideoList,
  getChannelList,
  getVideoDetail,
  parseUrl,
  getVideoOrder,
  getKs,
  getChannelOrder,
  getMediaFilters,
  getRelatedWebinar,
  getRelatedEvent,
  getRelatedTrend,
  getRelatedConcept
} from '@/axios/api/media'

const state = {}

const getters = {}

const mutations = {}

const actions = {
  async getCategoryListApi ({commit}, params) {
    try {
      let { data: res } = await getCategoryList(params)
      return res || []
    } catch (e) {
      return []
    }
  },
  async getCategoryDetailApi ({commit}, params) {
    try {
      let { data: res } = await getCategoryDetail(params)
      return res
    } catch (e) {
      return false
    }
  },
  async getChannelListApi ({commit}, params) {
    try {
      const { data: res } = await getChannelList(params)
      const channelThumbnail = res.channelThumbnailAndMediaCount || []
      const list = res.channels.map(v => {
        const thumbnail = channelThumbnail.find(item => String(item.channelId) === String(v.object.id))
        return {
          ...v.object,
          thumbnailUrl: thumbnail ? thumbnail.orginThumbnailUrl : ''
        }
      })
      return {
        list,
        totalCount: res.totalCount
      }
    } catch (e) {
      return false
    }
  },
  getChannelDetailApi ({commit}, params) {

  },
  async getVideoDetailApi ({commit}, params) {
    try {
      let { data: res } = await getVideoDetail(params)
      return res
    } catch (e) {
      return false
    }
  },
  async getVideoListApi ({commit}, params) {
    try {
      const { data: res } = await getVideoList(params)
      return res
    } catch (e) {
      return false
    }
  },
  async getVideoOrderApi ({commit}, params) {
    try {
      const { data: res } = await getVideoOrder(params)
      return res || []
    } catch (e) {
      return []
    }
  },
  async getChannelOrderApi ({commit}, params) {
    try {
      const { data: res } = await getChannelOrder(params)
      return res || []
    } catch (e) {
      return []
    }
  },
  async parseUrlApi ({commit}, params) {
    try {
      const { data: res } = await parseUrl(params)
      return res || {}
    } catch (e) {
      return false
    }
  },
  async getKsApi ({commit}, params) {
    try {
      const { data: res } = await getKs(params)
      return res || ''
    } catch (e) {
      return false
    }
  },
  async getMediaFiltersApi ({commit}, params) {
    try {
      const { data: res } = await getMediaFilters(params)
      return res || []
    } catch (e) {
      return false
    }
  },
  async getRelatedWebinarApi ({commit}, params) {
    try {
      let { data: res } = await getRelatedWebinar(params)
      return res
    } catch (e) {
      return false
    }
  },
  async getRelatedEventApi ({commit}, params) {
    try {
      let { data: res } = await getRelatedEvent(params)
      return res
    } catch (e) {
      return false
    }
  },
  async getRelatedTrendApi ({commit}, params) {
    try {
      let { data: res } = await getRelatedTrend(params)
      return res
    } catch (e) {
      return false
    }
  },
  async getRelatedConceptApi ({commit}, params) {
    try {
      let { data: res } = await getRelatedConcept(params)
      return res
    } catch (e) {
      return false
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/media.js